<template>
	<div>
		<form @submit.prevent class="xs-12 p2">
			<!-- Email -->
			<div class="xs-12 mb2">
				<j-base-input-text
					v-model="emailOfUserToBeInvited"
					:placeholder="$t('enter_email')"
					name="email"
					v-validate="'email|required'"
					:data-vv-as="$t('email')"
					:status="errors.first('email') ? 'error' : null"
				/>
			</div>

			<!-- Select Role -->
			<core-select-role
				v-model="role"
				name="role"
				v-validate="'required'"
				:data-vv-as="$t('role')"
				:status="errors.first('role') ? 'error' : null"
			/>

			<!-- Button -->
			<div class="flex xs-12 xs-center mt4">
				<j-button @click="inviteUser" :isLoading="isLoading" class="ml2">
					{{ $t("invite_user") }}
				</j-button>
			</div>
		</form>
	</div>
</template>

<script>
import JButton from "@/components/JButton/"
import JBaseInputText from "@/components/JBaseInputText/"
import CoreSelectRole from "@/modules/core/components/CoreSelectRole"
import api from "../api"
import crmConfig from "@/config/"

export default {
	components: { JButton, JBaseInputText, CoreSelectRole },
	props: {
		internalId: {
			validator(val) {
				return val === null || typeof val === "string"
			},
			required: true
		}
	},

	data() {
		return {
			// When inviting user through modal,
			// here we store info about the user that should be invited
			emailOfUserToBeInvited: null,
			isLoading: false,

			role: null
		}
	},

	methods: {
		async inviteUser() {
			// Validate email within modal
			if (!this.internalId) return
			const isValid = await this.$validator.validate()
			if (!isValid) return

			// 1: Invite user
			this.isLoading = true
			const res = await api.inviteInternal({
				clientId: crmConfig.CLIENT_ID,
				inviteInternalInput: {
					entityId: this.internalId, // id of internal
					email: this.emailOfUserToBeInvited,
					username: this.emailOfUserToBeInvited
				}
			})
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// 2: add permission group to user
			// When user is created, assign him a role
			const loginId = res.data.inviteInternal.id

			this.isLoading = true
			const res2 = await api.assignRole({
				loginId,
				permissionGroupId: this.role
			})
			this.isLoading = false

			if (res2.errors) {
				this.$store.dispatch("showError", res2.errors)
				return
			}

			// Emit
			// Show message
			this.$store.dispatch("addMessage", {
				message: { type: "success", text: this.$t("user_invited") }
			})

			this.$emit("invite:finished")
		}
	}
}
</script>
